import styled, { keyframes, css } from 'styled-components';

export const ViewHeightSection = styled('section')({
  height: '100vh',
  maxWidth: '1400rem',
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0 50rem',
  margin: '0 auto',
  '@media (max-width: 1200px)': {
    padding: '0 35rem',
  },
  '@media (max-width: 768px)': {
    height: '500rem',
    padding: '0 20rem',
    '&:last-child': {
      height: '700rem',
    },
  },
});

export const IconTop = styled('div')({
  position: 'absolute',
  top: '10%',
  left: '40%',
});

export const IconTopRight = styled('div')({
  position: 'absolute',
  top: '20%',
  right: '5%',
});

export const IconBottomRight = styled('div')({
  position: 'absolute',
  right: '10%',
  bottom: '25%',
  '@media (max-width: 768px)': {
    bottom: '30%',
  },
});

export const IconBottomLeft = styled('div')({
  position: 'absolute',
  left: '15%',
  bottom: '20%',
});

export const IconTopLeft = styled('div')({
  position: 'absolute',
  top: '25%',
  left: '5%',
  '@media (max-width: 768px)': {
    top: '30%',
  },
});

const scrollDownAnimation = keyframes({
  '0%': {
    opacity: 0,
    transform: 'translateY(-20rem) scale(0.7) rotateX(-90deg)',
  },
  '50%': {
    opacity: 1,
    transform: 'translateY(0) scale(1) rotateX(0)',
  },
  '100%': {
    opacity: 0,
    transform: 'translateY(20rem) scale(0.7) rotateX(90deg)',
  },
});

export const ScrollDown = styled('div')(
  ({ theme }) => ({
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    bottom: '10%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontSize: '13rem',
    color: theme.colors.tertiary_element,
    textTransform: 'uppercase',
    '& svg': {
      height: '32rem',
      marginBottom: '30rem',
    },
    '@media (max-width: 1200px)': {
      fontSize: '12rem',
      '& svg': {
        height: '30rem',
      },
    },
    '@media (max-width: 768px)': {
      display: 'none',
      visibility: 'hidden',
      // bottom: 0,
      // fontSize: '11rem',
      // '& svg': {
      //   height: '28rem',
      // },
    },
  }),
  css`
    & svg {
      animation: ${scrollDownAnimation} 2s infinite ease;
    }
  `
);

export const ScrollytellingSection = styled('section')({
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  '@media (max-width: 768px)': {
    minHeight: 'auto',
    height: 'auto',
  },
});

export const StickyContent = styled('div')({
  height: '100vh',
  width: '100%',
  position: 'sticky',
  top: 0,
  overflow: 'hidden',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '@media (max-width: 768px)': {
    height: '100%',
  },
});

export const AnimationText = styled('span')({
  position: 'absolute',
  opacity: 0,
  whiteSpace: 'nowrap',
  textAlign: 'center',
  '@media (max-width: 768px)': {
    maxWidth: '85%',
    whiteSpace: 'normal',
  },
});

export const MockupContent = styled('div')({
  height: '625rem',
  width: '100%',
  maxHeight: '70%',
  maxWidth: '70%',
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const AnimationMockupVideo = styled('video')({
  maxHeight: '95%',
  maxWidth: '89%',
  position: 'absolute',
});

export const PhoneMockupImage = styled('img')({
  maxHeight: '100%',
  maxWidth: '100%',
  position: 'absolute',
});

export const EmailNotifyForm = styled('form')({
  width: '90%',
  maxWidth: '600rem',
  display: 'flex',
  textAlign: 'center',
  '& > * + button': {
    marginLeft: '30rem',
  },
  '& .Subheading': {
    width: '90%',
    display: 'none',
  },
  '@media (max-width: 768px)': {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'normal',
    '& > * + button': {
      marginLeft: 0,
    },
    '& > * + *': {
      marginTop: '30rem',
    },
    '& .Subheading': {
      display: 'block',
    },
  },
});

export const EmailInput = styled('input')(({ theme }) => ({
  height: '66rem',
  width: '100%',
  flex: 1,
  padding: '0 30rem',
  boxSizing: 'border-box',
  borderRadius: '15rem',
  boxShadow: `0 10rem 10rem ${theme.colors.black}0A`,
  fontFamily: "'San Francisco', sans-serif",
  fontSize: '16rem',
  textAlign: 'left',
  color: theme.colors.secondary_element,
  '&::placeholder': {
    color: theme.colors.tertiary_element,
  },
  '@media (max-width: 768px)': {
    flex: 'none',
    padding: '0 25rem',
  },
}));

export const SubmitButton = styled('button')(({ theme }) => ({
  height: '66rem',
  padding: '0 40rem',
  boxSizing: 'border-box',
  background: `linear-gradient(-10deg, ${theme.colors.tertiary_background} 40rem, ${theme.colors.secondary_background}30)`,
  backgroundColor: theme.colors.tertiary_background,
  borderRadius: '15rem',
  fontFamily: "'Nexa', sans-serif",
  fontSize: '16rem',
  color: `${theme.colors.white}E6`,
  cursor: 'pointer',
  '@media (max-width: 768px)': {
    height: '58rem',
    width: '100%',
  },
}));

export const FormResponse = styled('span')({
  width: '80%',
  display: 'none',
  textAlign: 'center',
});
